import { Form } from "react-bootstrap";

const DocumentForm = ({ name, onChange, file, position, uploadStarted, uploadProgress }) => {
    return(
        <>
            <Form.Group className="form-group tif-mb-10" controlId={`${ name }FormSourceUrl`}>
                <Form.Label className="tif-font-md tif-mb-15">Source URL</Form.Label>
                <Form.Control
                    placeholder="Source URL"
                    value={ file.source_url }
                    disabled={ uploadStarted || uploadProgress === 100 }
                    onChange={e => onChange("source-url", e.target.value, position)}
                    className="small"
                />
            </Form.Group>
            <Form.Group className="form-group" controlId={`${ name }FormTitle`}>
                <Form.Label className="tif-font-md tif-mb-15">Title</Form.Label>
                <Form.Control
                    placeholder="Title"
                    value={ file.title }
                    disabled={ uploadStarted || uploadProgress === 100 }
                    onChange={e => onChange("title", e.target.value, position)}
                    className="small"
                />
            </Form.Group>
        </>
    );
};

export default DocumentForm;